'use strict';

jQuery($ => {
	// Open menu
	$('.gecko-header-touch__toggle').on('click', function(e){
		e.preventDefault;
		$('.gecko-touch-menu').toggleClass('action-show');
		$('.gecko-touch-menu__blackout').toggleClass('action-show');
	});

	// Toggle the menu on blackout click
	$('.gecko-touch-menu__blackout').on('click', function(e){
		$('.gecko-touch-menu').removeClass('action-show');
		$('.gecko-touch-menu__blackout').removeClass('action-show');
	});

	// Single click will open the menu, double click will proceed to link
	$('.gecko-touch-menu .menu > .menu-item-has-children > .sub-menu').append('<li class="menu-item close"><a href="#" class="close">Close <i class="fa fa-close"></i></a></li>');
	$('.gecko-touch-menu .menu > .menu-item > .sub-menu > .menu-item.close').click(function(e) {
		$(this).parent('.sub-menu')
			.toggleClass('show-sub-menu');
	});
	$('.gecko-touch-menu .menu-item-has-children').click(function(e) {
		if ($(this).hasClass('show-sub-menu')) {
			$(this).removeClass('show-sub-menu');
		} else {
			e.preventDefault();
			$(this).addClass('show-sub-menu');
		}
	});

});
